export default __webpack_public_path__ + "static/UNDEADPEPE-d46b7236e2833c4a04c24c594f0b3d31.jpg";